import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { getWisdomSystems } from "constants/constants";
import { getWatomsSystems } from '../../constants/constants';
import { useLanguage } from "context/LanguageContext";
import { useAuth } from "context/AuthContext";

const ModelNaviagtionSideBar = ({ defaultOpen = false, system = "wisdom" }) => {
    const { userInfo } = useAuth();
    const { language } = useLanguage();
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const wisdomModels = getWisdomSystems(
        language,
        userInfo?.organization_id,
        userInfo
    );
    const watomsModels = getWatomsSystems(
        language,
        userInfo?.organization_id,
        userInfo
    );
    const models = system === "wisdom" ? wisdomModels : watomsModels;

    return (
        <>
            <button
                onClick={() => setIsOpen(prev => !prev)}
                className="fixed top-4 left-4 z-[60] w-11 h-11 rounded-full bg-[#1c2952] text-white shadow-lg flex items-center justify-center"
            >
                <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
            </button>

            <aside
                className={`
          fixed left-0 top-0 h-screen w-64 bg-[#1c2952] text-white p-4 pt-20 z-50
          transition-transform duration-300
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
        `}
            >
                <h2 className="text-xl font-bold mb-6 text-center">
                    Navigation
                </h2>

                <nav className="flex flex-col gap-2">
                    {models
                        .filter(model => model.available === true)
                        .map((item, index) => (
                            <NavLink
                                key={index}
                                to={item.path}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-4 py-3 rounded-lg transition
                  hover:bg-white/10
                  ${isActive ? "bg-white/20" : ""}`
                                }
                            >
                                <FontAwesomeIcon icon={item.icon} className="text-lg" />
                                <span className="font-medium">{item.title}</span>
                            </NavLink>
                        ))}
                </nav>
            </aside>
        </>
    );
};

export default ModelNaviagtionSideBar;